import { APIError, ImportStatus, PERMISSION } from ".";

export enum CopyStatus {
  COPYING = "COPYING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export enum NetworkUpdateStatus {
  UPDATING = "UPDATING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export interface Scenario {
  id: number;
  name: string;
  baseline: boolean;
  copyStatus?: CopyStatus;
  copyErrors: APIError[];
  networkImportErrors: APIError[];
  networkImportStatus: ImportStatus;
  networkImportWarnings: APIError[];
  networkUpdateErrors: APIError[];
  networkUpdateStatus: NetworkUpdateStatus;
  permissions: {
    delete: PERMISSION;
    updateGeneralSettings: PERMISSION;
    updateBackground: PERMISSION;
    updateMeteo: PERMISSION;
    updateEmission: PERMISSION;
    deleteEmission: PERMISSION;
    updateLEZ: PERMISSION;
    updateResidential: PERMISSION;
  };
}
